module.exports = __webpack_public_path__ + "fonts/righthand-hairlineitalic-personal.ed43bd58.ttf";